import React from 'react'
import { Box, BoxProps, Button, Flex, FormControl, Input, Text, useColorModeValue } from '@chakra-ui/react'
import { Estimate as EstimateTypes, ResourceEstimate } from '../types'
import { FiDownload, FiTrash } from 'react-icons/fi'
import Resource from './Resource'
import { useMutation } from '../convex/_generated/react'

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

interface EstimateProps extends BoxProps {
  estimate: EstimateTypes
}

const Estimate: React.FC<EstimateProps> = ({
  estimate,
  ...rest
}) => {
  const updateEstimate = useMutation('updateEstimate')
  const deleteEstimate = useMutation('deleteDocument')

  const totalResources = estimate.resources ? estimate.resources.length : 0
  const bufferHours = estimate.buffer || 0

  const resources = estimate.resources || []
  const total = {
    actualCost: 0,
    estimatedCost: 0,
    profitPerHour: 0,
    profit: 0
  }
  resources.forEach(res => {
    total.actualCost += (res.actualCost || 0) * (res.hours || 0)
    total.estimatedCost += (res.chargePrice || 0) * (res.hours || 0)
  })

  total.profit = total.estimatedCost - total.actualCost

  const handleAddResource = () => {
    updateEstimate({
      ...estimate,
      resources: [
        ...(estimate.resources || []),
        {
          pricingType: 'HOURLY'
        }
      ]
    })
  }

  const handleBuffer = (e: any) => {
    updateEstimate({
      ...estimate,
      buffer: parseFloat(e.target.value)
    })
  }

  const handleDelete = (index: number) => {
    updateEstimate({
      ...estimate,
      resources: (estimate.resources || []).filter((e, i) => i !== index)
    })
  }

  const handleResourceChange = (data: ResourceEstimate, k: number) => {
    updateEstimate({
      ...estimate,
      resources: (estimate.resources || []).map((r, index) => {
        if (index === k) {
          return {
            ...r,
            ...data
          }
        }
        return r
      })
    })
  }

  return (
    <Box backgroundColor={useColorModeValue('white', 'whiteAlpha.50')} p={5} borderWidth={1} borderRadius={6} borderColor={useColorModeValue('transparent', 'whiteAlpha.200')} boxShadow='lg' {...rest}>
      <Flex mb={4} justifyContent="space-between">
        <Flex direction="column">
          <Text fontSize='2xl'>{ estimate.name }</Text>
        </Flex>
        <Flex gap={2}>
          <Button><FiDownload />&nbsp;&nbsp;Export</Button>
          <Button onClick={() => estimate._id && deleteEstimate(estimate._id)}><FiTrash size="20" /></Button>
        </Flex>
      </Flex>
      <Flex gap={3}>
        {/*
        <FormControl>
          <Text as="label" fontSize="sm">Buffer</Text>
          <Input onChange={handleBuffer} type="number" mt={2} placeholder="Buffer" />
        </FormControl>
        */}
        <FormControl>
          <Text as="label" fontSize="sm">Actual cost</Text>
          <Input mt={2} value={usd.format(total.actualCost)} readOnly placeholder="Actual cost" />
        </FormControl>
        <FormControl>
          <Text as="label" fontSize="sm">Estimate</Text>
          <Input mt={2} value={usd.format(total.estimatedCost)} readOnly placeholder="Estimate" />
        </FormControl>
        <FormControl>
          <Text as="label" fontSize="sm"># of resources</Text>
          <Input mt={2} value={(estimate.resources || []).length} readOnly placeholder="# of resources" />
        </FormControl>
        {/*
        <FormControl>
          <Text as="label" fontWeight={'bold'} fontSize="sm">Profit per hour</Text>
          <Input mt={2} borderColor={ total.profit < 0 ? 'red.500' : 'green.500'} borderWidth={2} value={usd.format(total.profitPerHour)} readOnly placeholder="Profit per hour" />
        </FormControl>
        */}
        <FormControl>
          <Text as="label" fontWeight={'bold'} fontSize="sm">Profit</Text>
          <Input mt={2} borderColor={ total.profit < 0 ? 'red.500' : 'green.500'} borderWidth={2} value={usd.format(total.profit)} readOnly placeholder="Profit" />
        </FormControl>
      </Flex>
      <Box pt={3} mt={4} borderColor={useColorModeValue('blackAlpha.300', 'whiteAlpha.200')} borderTopWidth={1}>
        {
          (!estimate.resources || estimate.resources.length <= 0)
            ? <Box color={useColorModeValue('blackAlpha.500', 'whiteAlpha.500')} textAlign="center" p={10}>
                <Text mb={1} fontSize="2xl">No resources!</Text>
                <Text mb={3}>No resources added to this estimate.</Text>
                <Button onClick={handleAddResource}>Add Resource</Button>
              </Box>
            : <Text color="whiteAlpha.600" fontSize="md">Resources</Text>
        }
        {
          (estimate.resources || []).map((resource, key) => (
            <Resource
              onDelete={() => handleDelete(key)}
              mt={3} key={key}
              onChange={(data) => handleResourceChange(data, key)}
              {...resource}
            />
          ))
        }
        {
          estimate.resources && estimate.resources.length > 0
            ? <Button onClick={handleAddResource} mt={4} size="sm">Add another resource</Button>
            : null
        }
      </Box>
    </Box>
  )
}

export default Estimate
